import { render, staticRenderFns } from "./OrganizerTicketReprints.vue?vue&type=template&id=133af87c&"
import script from "./OrganizerTicketReprints.vue?vue&type=script&lang=js&"
export * from "./OrganizerTicketReprints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports